import dayjs from "dayjs";
import { createContext, useState } from "react";
import { ContextProviderProps } from "../../types";
import { MinistryState, UpdateMinistryFunction } from "./ministry.types";

export const initialState = (): MinistryState => {
  return {
    //Response for mfSviZahteviZaMarkicu

    filters: [],
    vrsteFilters: [],
    mfAllZahtevi: [],

    //Response for informacijeNapravljenogZahtevaZaMarkicu

    brojPorudzbenice: "",
    markicaZahteviDrustvoInfoDto: {
      naziv: "",
      imeGrada: "",
      adresa: "",
      pib: "",
      maticniBroj: "",
      brojTekucegRacuna: [],
      preteznaDelatnost: "",
      ovlascenaLicaZaPreuzimanjeMarkica: [],
    },
    dokumentSpecifikacijaDetails: null,
    statusZahteva: "",
    kategorijaVrstaZahtevaDto: [],
    kategorijaProizvodaId: null,
    imaPakovanje: false,
    evidencioniBroj: "",
    showNedostajuceVrednosti: false,
    isPlacen: false,
    stampajPredracun: false,
    isVracenNaDopunu: false,
    markicaZahtevStatusNotes: [],
    zahtevZaMarkicuUvoznik: {
      inostraniProizvodjacNaziv: "",
      inostraniProizvodjacPoreskiBroj: "",
      inostraniProizvodjacAdresa: "",
      inostraniProizvodjacMesto: "",
      distributerInostranogProizvodjacaNaziv: "",
      distributerInostranogProizvodjacaPoreskiBroj: "",
      distributerInostranogProizvodjacaAdresa: "",
      distributeraInostranogProizvodjacaMesto: "",
      distributerInostranogProizvodjacaAdresaSlanjaMarkica: "",
    },
    markicaZahtevStatusi: {
      odobren: null,
      odbijen: null,
      vracenNaDopunu: null,
    },
    showMfinNote: false,

    //Response for mfListaAkciznihSkladista

    filtersSkladista: [],
    akciznaSkladista: [],

    //Response for detaljiOSkladistu

    detaljiOSkladistu: {
      tipDozvole: null,
      planiranaProizvodnjaProizvodaDuvanaKg: null,
      kolicinaPojedinacnihPakovanjaKomadi: null,
      kolicinaProizvodaIzPrethodneGodineDuvanaKg: null,
      kolicinaProizvodaIzPrethodneGodineDuvanaKomadi: null,
      prosecanMesecniRashodDuvanaKg: null,
      prosecanMesecniRashodDuvanaKomadi: null,
      isReadonly: false,
      evidencioniBroj: "",
      mfinStatusi: [],
      drustvoInfo: {
        nazivObveznika: "",
        mestoSedista: "",
        preteznaDelatnost: "",
        pib: "",
      },
      vrstaAkciznogProizvoda: "",
      adresaProizvodnje: {
        ulicaIBrojProizvodnje: "",
        postanskiBrojProizvodnje: "",
        mestoProizvodnje: "",
      },
      kolicinaUskladistenihProizvoda: null,
      kategorijaProizvodaId: null,
      prosecanMesecniRashod: null,
      tipResenjaId: null,
      dokumentId: null,
      dozvolaZahtevId: null,
      nacinOtpremanja: "",
      podatakOMernimUredjajima: "",
      brojResenja: "",
      datumResenjaNadleznogOrgana: "",
      kolicinaProizvodaIzPrethodneGodine: null,
      planiranaProizvodnjaProizvoda: null,
      brojSkladistaZaDozvolu: "",
      adresaSkladista: {
        ulicaIBrojSkladista: "",
        postanskiBrojSkladista: "",
        mestoSkladista: "",
      },
      planiranaProizvodnjaProizvodaDuvanaKomadi: null,
      tarfinaOznaka: "",
      oznakaSkladista: "",
      meraTip: "",
      meraVrednost: "",
      opisSkladista: "",
      opisRadaRacunovodstva: "",
      dozvolaZahteviDostavljeniDokazi: [],
      kolicinaDuvanaKg: 0,
    },

    //Response for mfObradiZahtevZaDozvolu

    mfObradiZahtevZaDozvoluId: null,

    //Response for mfListaAkciznihDozvola

    filterTipResenja: [],
    filterStatus: [],
    akcizneDozvole: [],

    //Response for detaljiZahtevaDozvole

    detaljiODozvoli: {
      tipDozvole: null,
      isReadonly: false,
      mfinKomentari: {
        isPoreskaPositive: null,
        brojResenja: "",
        datumVazenja: "",
        komentar: "",
        dokumentResenja: { id: null, dokumentUrl: "" },
      },
      mfinStatusi: [],
      statusZahteva: "",
      showPrekidVazenjaNote: false,
      prekidVazenjaNote: "",
      misljenjePoreske: "",
      dokumentiIzPoreske: [],
      evidencioniBroj: "",
      dozvolaZahtevId: null,
      isVracenNaDopunu: false,
      isKompletan: false,
      isOdobren: false,
      isOdbacen: false,
      isOdbijen: false,
      isIzvrsenaPoreskaKontrola: false,
      isPodnet: false,
      statusNotes: null,
      odabranaKategorijaProizvoda: "",
      drustvoInformacije: {
        nazivObveznika: "",
        mestoSedista: "",
        preteznaDelatnost: "",
        pib: "",
      },
      akciznoSkladisteTipoviResenja: [],
      resenjeInformacije: {
        resenjeId: null,
        brojResenja: "",
        datumIzdavanja: "",
        datumVazenja: "",
        tipResenja: null,
        aktivno: false,
        komentariZaResenje: [],
        dokumentiResenja: [],
      },
      mereVelicine: [],
      dokumentiZaDozvolu: [],
      dozvolaInformacije: {
        tipDozvole: null,
        tarifnaOznaka: "",
        kategorijaProizvodaId: null,
        ulicaProizvodnje: "",
        brojUliceProizvodnje: "",
        postanskiBrojProizvodnje: "",
        mestoProizvodnje: "",
        nacinOtpremanja: "",
        podatakOMernimUredjajima: "",
        brojResenja: "",
        datumResenjaNadleznogOrgana: "",
        datumResenjaNadleznogOrganaPrikaz: "",
        kolicinaUskladistenihProizvoda: null,
        kolicinaDuvanaKg: null,
        kolicinaPojedinacnihPakovanjaKomadi: null,
        prosecanMesecniRashod: null,
        prosecnaKolicinaDuvanaKg: null,
        prosecnaKolicinaPojedinacnihPakovanjaKomadi: null,
      },
      skladisteInformacije: {
        skladisteId: null,
        kolicinaProizvodaIzPrethodneGodine: null,
        kolicinaProizvodaIzPrethodneGodineKg: null,
        kolicinaProizvodaIzPrethodneGodineKomadi: null,
        planiranaProizvodnjaProizvoda: null,
        planiranaProizvodnjaProizvodaKg: null,
        planiranaProizvodnjaProizvodaKomadi: null,
        brojSkladistaZaDozvolu: "",
        meraTip: "",
        ulicaSkladista: "",
        brojUliceSkladista: "",
        postanskiBrojSkladista: "",
        mestoSkladista: "",
        oznakaSkladista: "",
        opisSkladista: "",
        opisRadaRacunovodstva: "",
        meraVelicineSkladista: null,
        meraVrednost: null,
      },
    },

    //Payload for mfIzdavanjeResenja

    isPoreskaPositive: null,
    dozvolaZahtevId: null,
    brojResenja: "",
    datumVazenja: dayjs().add(1, "day"),
    tipResenja: null,
    komentar: "",
    dokumentResenja: {
      data: "",
      format: "",
    },

    //Response for mfIzdavanjeResenja

    resenjeId: null,

    //Response for mfSveMarkiceVracenih

    markiceVracenih: [],

    //SelectedStamps

    selectedMarkicaId: null,
    selectedLicenceId: null,
    selectedWarehouseId: null,
    updatedZahtevStatusId: null,
    datumIsporuke: null,
  };
};

interface IMinistryContext {
  ministry: MinistryState;
  setMinistry: UpdateMinistryFunction;
  clearMinistryState: () => void;
  clearPayloadState: () => void;
}

export const MinistryContext = createContext<IMinistryContext>(null as any);

export const MinistryContextProvider = ({ children }: ContextProviderProps) => {
  const [ministry, setMinistryState] = useState(initialState());

  const handleSetMinistry = (updatedState: Partial<MinistryState>) => {
    const newState = { ...ministry, ...updatedState };
    setMinistryState(newState);
  };

  const setMinistry = (updatedState: Partial<MinistryState>) => {
    handleSetMinistry({ ...updatedState });
  };

  const clearMinistryState = () => {
    setMinistryState(initialState());
  };

  const clearPayloadState = () => {
    const updatedState: Partial<MinistryState> = {
      dozvolaZahtevId: null,
      brojResenja: "",
      datumVazenja: null,
      tipResenja: null,
      komentar: "",
      dokumentResenja: { data: null, format: "" },
    };
    setMinistry(updatedState);
  };

  return (
    <MinistryContext.Provider
      value={{
        ministry,
        setMinistry,
        clearMinistryState,
        clearPayloadState,
      }}
    >
      {children}
    </MinistryContext.Provider>
  );
};
